import { render, staticRenderFns } from "./sundry-transactions-list.vue?vue&type=template&id=6706a4a6"
import script from "./sundry-transactions-list.vue?vue&type=script&lang=js"
export * from "./sundry-transactions-list.vue?vue&type=script&lang=js"
import style0 from "./sundry-transactions-list.vue?vue&type=style&index=0&id=6706a4a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports